import { render } from "./ChildInfo.vue?vue&type=template&id=226eadf5&scoped=true"
import script from "./ChildInfo.vue?vue&type=script&lang=js"
export * from "./ChildInfo.vue?vue&type=script&lang=js"

import "./ChildInfo.vue?vue&type=style&index=0&id=226eadf5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226eadf5"]])

export default __exports__